// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { applyAspectRatioBoxStyles, applyAspectRatioBoxInsideStyles } from '@tcp/core/src/utils';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';

const StyledImageContainer = styled.div`
  ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;

const StyledDamImage = styled(DamImage)`
  ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;

const StyledWrapper = styled.div`
  ${(props) => (!isEmpty(props.spacingTop) ? `margin-top: ${props.spacingTop}px;` : ``)}
  ${(props) => (!isEmpty(props.spacingBottom) ? `margin-bottom: ${props.spacingBottom}px;` : ``)}
`;

export default css`
  .moduleD_button {
    margin: 0 auto 32px;
    width: 225px;
    padding: 15px 0;

    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 11px 0;
      width: 162px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0 auto 48px;
      width: 210px;
    }
  }
  .moduleD_header {
    margin-bottom: 16px;
  }
  .moduleD_tile {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .moduleD_link {
    text-align: center;
    color: ${(props) => props.theme.colorPalette.text.primary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  }
  .moduleD_image {
    width: 100%;
  }
  .moduleD__promo-banner {
    margin-bottom: 16px;
  }

  .button-list-wrapper {
    padding: 0;
  }

  .button-list-container {
    padding: 16px 0;
  }

  .button-list-container.stackedCTAList {
    padding: 0;
  }

  .button-list-container.imageCTAList .image-comp,
  .button-list-container.linkCTAList .link-button-wrapper-class {
    color: ${(props) => props.theme.brandSpecificStyles.MODULE_D.IMAGE_CTA_COLOR};
  }
  .button-list-container.linkCTAList .link-button-wrapper-class {
    border-bottom-color: #ffffff;
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => props.theme.brandSpecificStyles.MODULE_D.IMAGE_CTA_LIST_FONT_WEIGHT}
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .button-list-container.stackedCTAList {
      padding: 16px 0 0;

      .wrapped-button-text .stacked-button .cta-button-text {
        padding: 11px 0;
      }
    }
  }

  &.brand-tcp.page-home .fixed_medium_text_black {
    font-family: TofinoCond;
    font-weight: 700;
    font-size: 32px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: 48px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 88px;
    }
  }

  .moduleD-grid-button {
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 1.3px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    color: ${(props) => props.theme.colorPalette.gray[800]};
    background-color: ${(props) => props.theme.colors.WHITE};
    min-height: 51px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: ${(props) => props.theme.fonts.fontSize.listmenu.small}px;
      min-height: 42px;
    }
  }
`;

export { StyledImageContainer, StyledDamImage as DamImage, StyledWrapper as Wrapper };
